import { render, staticRenderFns } from "./TheChart.vue?vue&type=template&id=283e853c&"
import script from "./TheChart.vue?vue&type=script&lang=js&"
export * from "./TheChart.vue?vue&type=script&lang=js&"
import style0 from "./TheChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports